<template>
  <!-- Page Not found start here -->
  <section class="page-not-found">
    <div class="container">
      <div class="not-found-text">
        <img :src="require('@/assets/img/404-page.svg')" alt="" />
        <h2>Oops! Page not found</h2>
        <p>
          The page you are trying to access does not exist or has been moved.
          Try going back to our homepage.
        </p>
        <router-link to="/" class="btn back-home-btn">Back Home</router-link>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "404HTML.vue",
};
</script>

<style scoped></style>
